import React from 'react'
import { Layout, Stack, Main } from '@layout'
import PageTitle from '@components/PageTitle'
import Divider from '@components/Divider'
import Seo from '@widgets/Seo'

const contact = props => (
  <Layout {...props}>
    <Seo title='Contact' />
    <Divider />
    <Stack>
      <Main>
        <PageTitle
          header="お気軽にお問合せください。"
          subheader='TwitterのDMにてご連絡ください。'
        />
        <Divider />
      </Main>
    </Stack>
  </Layout>
)

export default contact;